import { BbchStageBase } from 'farmdok-rest-api';

import { Api } from '@/plugins/farmdokRestApi';

let cachedBbchStages: BbchStageBase[] | null = null;
let bbchStagesLoadingPromise: Promise<BbchStageBase[]> | null = null;

async function fetchBbchStagesPage(api: Api, pageKey?: string): Promise<BbchStageBase[]> {
  const response = await api.bbchApi.bbchStageList({ pageKey });
  const pageStages = response.data.data ?? [];
  const nextPageKey = response.data.pageKey ?? undefined;

  if (!nextPageKey) {
    return pageStages;
  }

  return pageStages.concat(await fetchBbchStagesPage(api, nextPageKey));
}

export function getCachedBbchStages(): BbchStageBase[] | null {
  return cachedBbchStages;
}

export async function loadBbchStages(api: Api | null | undefined): Promise<BbchStageBase[]> {
  if (cachedBbchStages) {
    return cachedBbchStages;
  }

  if (!api) {
    return [];
  }

  if (bbchStagesLoadingPromise) {
    return bbchStagesLoadingPromise;
  }

  bbchStagesLoadingPromise = fetchBbchStagesPage(api)
    .then((bbchStages) => {
      cachedBbchStages = bbchStages;
      return bbchStages;
    })
    .catch(() => {
      cachedBbchStages = [];
      return [];
    });

  try {
    return await bbchStagesLoadingPromise;
  } finally {
    bbchStagesLoadingPromise = null;
  }
}
